import React from "react";
import { createRoot } from "react-dom/client";
import ScrollExpand from "./ScrollExpand";

export function mountClosingExpand(root = document) {
	root.querySelectorAll("[data-scroll-expand]").forEach(element => {
		if (element.dataset.mounted) return;
		element.dataset.mounted = "true";
		element.classList.add("studio-scroll-closing");
		createRoot(element).render(
			<ScrollExpand src="/assets/solufy_website/images/auth-atmosphere.svg" alt=""
				title="Connected. Simplified." scrollHint="Scroll to your next chapter"
				useWindowScroll startWidth={68} startHeight={68} mediaZoom={1.15}
				scrollDistance={0.6} holdDistance={0.12} smoothing={0} overlayScrim={0.7}>
				<p className="studio-eyebrow">Your next chapter</p>
				<h2 id="studio-closing-title">Let’s make work<br /><em>flow better.</em></h2>
				<a className="studio-button" href="/contact">Start a conversation <span aria-hidden="true">↗</span></a>
				<p>Consulting. Engineering. A partnership that lasts.</p>
			</ScrollExpand>
		);
	});
}
